module.exports = __webpack_public_path__ + "img/_growmark.2b27bb50.png";